/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
import ValueSearchType from './ValueSearchType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/ValueSearchType (runtime) // new

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="caseSensitiveSearch" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="valueSearch" type="{}valueSearchType" minOccurs="0"/&gt; &lt;element name="valueList" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class CustomSort extends ObjectType{

	caseSensitiveSearch = null;

	valueSearch = null;

	valueList = null;



	/**
	 * Gets the value of the caseSensitiveSearch property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isCaseSensitiveSearch() {
		return this.caseSensitiveSearch;
	}

	/**
	 * Sets the value of the caseSensitiveSearch property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setCaseSensitiveSearch(value) {
		var oldValue = this.caseSensitiveSearch;
		this.caseSensitiveSearch = value;
		this._setAndNotify(243, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the valueSearch property.
	 * @return {ValueSearchType} possible object is {@link ValueSearchType}
	 */
	getValueSearch() {
		return this.valueSearch;
	}

	/**
	 * Sets the value of the valueSearch property.
	 * @param {ValueSearchType} value allowed object is {@link ValueSearchType}
	 */
	setValueSearch(value) {
		var oldValue = this.valueSearch;
		this.valueSearch = value;
		this._setAndNotify(244, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the valueList property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the valueList property. <p> For example, to add a new item, do as follows: <pre> getValueList().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getValueList() {
		if (!this.valueList) {
			this.valueList = [];
		}
		return this.valueList;
	}

	/**
	 * Gets the value of the <code>valueList</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetValueList() {
		return this.valueList;
	}

	/**
	 * Creates a new instance of <code>CustomSort</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> CustomSort</code> object from.
	 * @return {CustomSort} an object of type <code>CustomSort</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createCustomSort();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addValueListAt(position, item) {
		this._addAtAndNotify(this.getValueList(), position, item, 245, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addValueList(item) {
		this.addValueListAt(this.getValueList().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeValueListAt(position) {
		this._removeAtAndNotify(this.getValueList(), position, 245, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeValueList(item) {
		var i = this.getValueList().indexOf(item);
		if (i >= 0) {
			this.removeValueListAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "CustomSort";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 243, "caseSensitiveSearch", null));
		featureList.push(this.createFeature(false, true, false, 244, "valueSearch", ValueSearchType));
		featureList.push(this.createFeature(true, false, false, 245, "valueList", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 243:
			this.setCaseSensitiveSearch((value));
			break;
		case 244:
			this.setValueSearch((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 245:
			this.valueList = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 243:
			return this.isCaseSensitiveSearch();
		case 244:
			return this.getValueSearch();
		case 245:
			return this.getValueList();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 243:
			return this.isCaseSensitiveSearch();
		case 244:
			return this.getValueSearch();
		case 245:
			return this.basicGetValueList();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 245:
			this.addValueListAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 245:
			this.addValueList((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 245:
			this.removeValueListAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 245:
			this.removeValueList((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/CustomSort.js